export const GET_DAILY_REPORTS_STARTED = 'GET_DAILY_REPORTS_STARTED';
export const GET_DAILY_REPORTS = 'GET_DAILY_REPORTS';
export const GET_DAILY_REPORTS_ENDED = 'GET_DAILY_REPORTS_ENDED';

export const GET_CLOSED_REPORTS_STARTED = 'GET_CLOSED_REPORTS_STARTED';
export const GET_CLOSED_REPORTS = 'GET_CLOSED_REPORTS';
export const GET_CLOSED_REPORTS_ENDED = 'GET_CLOSED_REPORTS_ENDED';
